<div class="audit-details-header">
  <div class="grid">
    <div class="col-fixed" style="width:75%">
      <div class="font-semibold">User</div>
      <div class="mt-1">
        {{ auditTrialDetails.user }}
      </div>
    </div>
    <div class="col-fixed" style="width:25%">
      <div class="font-semibold">Date</div>
      <div class="mt-1">
        {{ auditTrialDetails.timestamp | date : "dd-MMM-yyyy HH:mm": "UTC"}} {{timeZoneFormat}}
      </div>
    </div>
  </div>
</div>
<hr />
<div class="audit-details-Content">
  <ng-container
    *ngFor="let attributeDetail of auditTrialDetails.attributeDetails"
  >
    <div class="grid mt-2">
      <div
        class="col-3 attribute-name-label"
        pTooltip="{{ attributeDetail.attributeName }}"
        tooltipPosition="{{ 'top' }}"
      >
        {{ attributeDetail.attributeName }}
      </div>
      <div class="col-9">
        <ul
          class="currentValue-container mr-2"
          *ngIf="attributeDetail.currentValue.length > 0"
        >
          <li *ngFor="let val of attributeDetail.currentValue">{{ val }}</li>
        </ul>
        <ul
          class="mr-2 previousValue-container"
          *ngIf="attributeDetail.previousValue.length > 0"
        >
          <li *ngFor="let val of attributeDetail.previousValue">{{ val }}</li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>
